'use client';

import { PromoCode } from '@repo/common/types';
import { useRef } from 'react';

export function CopyCodeButton({ coupon }: { coupon: PromoCode }) {
  const elRef = useRef<HTMLSpanElement>(null); // Move useRef here

  const handleClick = () => {
    navigator?.clipboard.writeText(coupon.code);

    const selection = window.getSelection();
    const range = document.createRange();
    if (elRef.current) {
      range.selectNodeContents(elRef.current);
      selection?.removeAllRanges(); // Clear any existing selections
      selection?.addRange(range); // Select the text of the span element
    }
  };

  return (
    <div className="relative mt-5 rounded-full border border-slate-300 p-4 pr-28 font-extrabold">
      <span ref={elRef}>{coupon.code}</span>
      <button
        onClick={handleClick}
        className=":hover absolute inset-y-1 right-1 left-auto ml-2 rounded-full bg-green-600 p-2 px-6 text-white hover:bg-green-600 active:bg-green-700"
      >
        Copy
      </button>
    </div>
  );
}
